import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, filter, finalize, Observable, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import {
  EnableDisableRequest,
  GetAllBuildingScan,
  GetUser,
} from 'src/app/core/models/admin';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { environment } from 'src/environments/environment';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class BuildingScanService {
  baseUrl = environment.apiUrl.concat('building-scan-management/');

  constructor(
    private http: HttpClient,
    private commonUtils: CommonUtils,
    private errorHandler: ErrorhandleService,
  ) {}

  /**
   *Get a list of all building scan exceptions
   *
   * @return {*}  {Observable<GetAllBuildingScan>}
   * @memberof UserService
   */
  getAllExceptionCodes(location: string): Observable<GetAllBuildingScan> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<GetAllBuildingScan>(this.baseUrl.concat('get-all-exception-codes'), {
        headers: { location: location },
      })
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<GetAllBuildingScan>(
            error,
            error.status,
            'Building Scan Service: Get All Exception Codes',
            BANNER_TYPE.TABLE_DATA_ERROR,
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }

  /**
   *Get a specific user passing in the loginId.
   *Used mainly to get currently logged in user
   * @param {string} [loginId]
   * @return {*}  {Observable<GetUser>}
   * @memberof UserService
   */
  enableDisableExceptions(
    data: EnableDisableRequest,
    location: string,
    locationGroup: string,
  ) {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .post<GetUser>(this.baseUrl.concat('enable-disable'), data, {
        headers: { location: location, locationGroup: locationGroup },
      })
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<GetUser>(
            error,
            error.status,
            'Building Scan Service: Enable/Disable Exceptions',
          ),
        ),
        filter((value) => !!value),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }
}
